import React from "react"
import autobind from "class-autobind"
import { Dialog, FlatButton, TextField, Toggle } from "material-ui"
import strings from "../../localization/strings"
import { IJobPhase } from "../../models"
import * as utils from "../../helpers/utils"
import AppStateStore from "../../stores/AppStateStore"
import * as api from "../../api"
import { checkPhaseFieldAvailable } from "../../helpers/punchHelper"
import AccountStore from "../../stores/AccountStore"
interface IProps {
    editPhase: IJobPhase
    phases: IJobPhase[]
    handleClose(): void
    handleAdd(phase: IJobPhase): void
    handleUpdate(phase: IJobPhase): void
}
interface IState {
    name: string
    errorName: string
    costCode: string
    active: boolean
}

export default class AddPhaseDialog extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            name: props.editPhase && props.editPhase.Name || "",
            errorName: "",
            costCode: props.editPhase && props.editPhase.CostCode || "",
            active: props.editPhase ? props.editPhase.Active : true
        }
        autobind(this)
    }

    handleSave() {
        if (!this.checkValidate()) return
        if (this.props.editPhase) {
            const { editPhase } = this.props
            editPhase.Name = this.state.name.trim()
            editPhase.CostCode = this.state.costCode.trim() ? this.state.costCode.trim() : null
            editPhase.Active = this.state.active
            this.props.handleUpdate(editPhase)
        }
        else {
            const phase = {
                Id: utils.guid(),
                Name: this.state.name.trim(),
                CostCode: this.state.costCode.trim() ? this.state.costCode.trim() : null,
                Active: true,
                Deleted: false,
            } as IJobPhase
            this.props.handleAdd(phase)
        }
    }

    checkValidate() {
        let isValidate = true
        if (!this.state.name.trim()) {
            this.setState({ errorName: strings.NameRequired })
            isValidate = false
        }
        else {
            if (this.props.phases.filter(i => this.props.editPhase ? i.Id !== this.props.editPhase.Id : true).find(i => i.Name === this.state.name.trim())) {
                this.setState({ errorName: strings.Name_is_duplicated })
                isValidate = false
            }
            else {
                this.setState({ errorName: "" })
            }
        }
        return isValidate
    }

    render() {
        return (
            <Dialog
                open
                title={this.props.editPhase ? 
                    checkPhaseFieldAvailable("singular") ?`Edit ${AccountStore.getCurrentAccountSettings().CustomFieldSettings.PhaseFieldLabels.SingularPhaseLabel}`:
                    strings.Edit_Phase 
                    : checkPhaseFieldAvailable("singular") ?`Add ${AccountStore.getCurrentAccountSettings().CustomFieldSettings.PhaseFieldLabels.SingularPhaseLabel}`: strings.Add_Phase}
                titleStyle={{ paddingLeft: 35, paddingBottom: 10 }}
                actions={[
                    <FlatButton
                        data-intercom-target={"menu-Jobs-JobDetails-PhasesTab-Btn-AddPhaseDialog"}
                        label={strings.CANCEL}
                        secondary
                        onClick={this.props.handleClose}
                    />,
                    <FlatButton
                        data-intercom-target={"menu-Jobs-JobDetails-PhasesTab-Btn-SavePhase"}
                        label={strings.SAVE}
                        primary
                        onClick={this.handleSave}
                    />
                ]}
            >
                <div style={{ paddingRight: 20, paddingLeft: 20 }}>
                    <TextField
                        data-intercom-target={"menu-Jobs-JobDetails-PhasesTab-Entry-Name"}
                        floatingLabelText={strings.Name}
                        value={this.state.name}
                        onChange={(e, value) => { this.setState({ name: value }, () => this.checkValidate()) }}
                        errorText={this.state.errorName}
                        errorStyle={{ position: "absolute", bottom: -10 }}
                        fullWidth
                    />
                    <TextField
                        data-intercom-target={"menu-Jobs-JobDetails-PhasesTab-Entry-CostCode"}
                        floatingLabelText={strings.Cost_Code}
                        value={this.state.costCode}
                        onChange={(e, value) => this.setState({ costCode: value })}
                        fullWidth
                    />
                    {this.props.editPhase &&
                        <Toggle
                            data-intercom-target={"menu-Jobs-JobDetails-PhasesTab-Toggle-Active"}
                            toggled={this.state.active}
                            label={strings.Active}
                            onToggle={(_, active) => {
                                if (active) {
                                    this.setState({ active })
                                }
                                else {
                                    AppStateStore.setProgressSnackbarContent("loading")
                                    api.allowDeleteOrInactivePhases([this.props.editPhase.Id]).then(res => {
                                        AppStateStore.setProgressSnackbarContent(null)
                                        res.data ?
                                            this.setState({ active }) :
                                            AppStateStore.setAlertDialogContent({
                                                title: strings.Cannot_Inactive_Phase,
                                                content: strings.Cannot_Inactive_Phase_because_it_is_already_use
                                            })
                                    })
                                }
                            }}
                            style={{ width: 250, marginTop: 30 }}
                        />
                    }
                </div>
            </Dialog>
        )
    }
}